/**
* @author lmcarrillo <lmcarrillo@sergas.net>
* @copyright Boqueixon 2023
* @version 20.60.60
* @license licenses.txt
*
* @date 2023-03-19 12:47:50
**/

import { Component , OnInit } from "@angular/core";
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from "@angular/router";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { environment } from "./../../../../src/environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { Storage } from "@ionic/storage";
import { Globals } from "../../class/globals/globals";
import { TranslateConfiguration } from "../../class/translate-configuration/translate-configuration";
import { ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";
import { PostsService } from "./../../services/posts/posts.service";
import { ToastController } from "@ionic/angular";
import { AlertController } from "@ionic/angular";
import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
import { HostListener } from "@angular/core";
import { PopoverController } from "@ionic/angular";
import { PopoverComponent } from "../../components/popover/popover.component";



@Component({
	selector: "app-post-detail",
	templateUrl: "post-detail.page.html",
	styleUrls: ["post-detail.page.scss"],
})

export class PostDetailPage {

	//url parameter
	public postId : string;

	
	pageName:string = `post-detail` ;
	
	/**
	* PostDetailPage:constructor()
	**/
	constructor(
		private router: Router,
		public statusBar: StatusBar,
		public translateService: TranslateService,
		public postsService: PostsService,
		public toastController: ToastController,
		public alertController: AlertController,
		public inAppBrowser: InAppBrowser,
		public popoverController: PopoverController,
		public activatedRoute: ActivatedRoute,
		private storage: Storage,
		private globals: Globals,
		private translateConfiguration: TranslateConfiguration
	){
	
		// statusbar
		this.statusBar.styleBlackOpaque();
		this.statusBar.overlaysWebView(false);
		this.statusBar.backgroundColorByHexString("#0955b3");
	
		// translate
		this.translateConfiguration.setDefaultLanguage();

	
	
		this.postId = this.activatedRoute.snapshot.paramMap.get("post_id");
		//is bookmark?
		this.isBookmark();
		

		console.log(`PostDetailPage`,`pageName`,this.pageName);
	}
	
	/**
	* PostDetailPage:showPopover()
	**/
	async showPopover(ev: any) {
		const popover = await this.popoverController.create({
			component: PopoverComponent,
			event: ev,
			translucent: true
		});
		return await popover.present();
	}
	
	


		
	post: Observable<any>;
	dataPost: any = {};
	bookmark:any = [];
	
	latestPosts: Observable<any>;
	dataLatestPosts: any = [];
	
	
	/**
	* PostDetailPage:showLatestPosts()
	**/
	public showLatestPosts(){
		let param = {per_page:5};
		this.latestPosts = this.postsService.getPosts(param);
		this.latestPosts.subscribe(data => {
			this.dataLatestPosts = data ;
		});
	}
	
	
	/**
	* PostDetailPage:getPost(postId)
	**/
	public getPost(){
		this.post = this.postsService.getPost(this.postId);
		this.post.subscribe(data => {
				this.dataPost = data ;
		});
	}
	
	
	/**
	* PostDetailPage:doRefresh()
	**/
	public doRefresh(refresher){
		this.dataPost = {};
		this.getPost();
		this.dataLatestPosts = [];
		this.showLatestPosts();
		setTimeout(() => {
			refresher.target.complete();
		}, 2000);
	}
	
	
	/**
	* PostDetailPage:getItem(table:string,key:string)
	**/
	public async getItem(table:string,key:string){
		this.storage.get(`${table}:${key}`).then((val) => {
			this.bookmark = val;
		});
	}
	
	
	/**
	* PostDetailPage:setItem(table:string,key:string,val:any)
	**/
	public async setItem(table:string,key:string,value:any){
		return await this.storage.set(`${table}:${key}`,value);
	}
	
	
	/**
	* PostDetailPage:removeItem(table:string,key:string)
	**/
	public async removeItem(table:string,key:string){
		return await this.storage.remove(`${table}:${key}`);
	}
	
	
	/**
	* PostDetailPage:addToBookmark()
	**/
	addToBookmark(){
		let key = this.dataPost.id ;
		let val = this.dataPost;
		this.setItem(`bookmarks`,key,val);
		
	}
	
	
	/**
	* PostDetailPage:removeBookmark()
	**/
	removeBookmark(){
		let key = this.dataPost.id ;
		this.removeItem(`bookmarks`,key);
		
	}
	
	
	
	/**
	* PostDetailPage.showToast($message)
	**/
	async showToast(message: string){
		const toast = await this.toastController.create({
			message: message,
			position: "bottom",
			color: "undefined",
			duration: 500
		});
		await toast.present();
	}
	
	
	/**
	* PostDetailPage:isBookmark()
	**/
	runBookmark:any ;
	isBookmark(){
		setInterval(() => {
			let key = this.dataPost.id ;
			this.getItem(`bookmarks`,key);
			//console.log("bookmarks",this.bookmark);
		},1000);
		
	}
	
	
	/**
	* PostDetailPage:ionViewDidLeave()
	**/
	ionViewDidLeave(){
		clearInterval(this.runBookmark);
	}
	
	
	/**
	* PostDetailPage.showAlert()
	**/
	async showAlert(header:string, subheader: string, message: string){
		const alert = await this.alertController.create({
			header: header,
			subHeader: subheader,
			message: message,
			buttons: ["OK"]
		});
		await alert.present();
	}
	
	
	/**
	* HostListener
	**/
	
	@HostListener("click", ["$event"]) onClick(e){
		if(e.target.href && e.target.target){
			if((e.target.target == `_blank`) || (e.target.target == `_system`)){
				let href = e.target.href;
				this.inAppBrowser.create(href,"_system");
			}
		}
	}
	
	
	/**
	* PostDetailPage:ngOnInit()
	**/
	public ngOnInit(){
		this.dataPost = {};
		this.getPost();
		this.dataLatestPosts = [];
		this.showLatestPosts();
	}
	
	




}
